/**
 * The website's questions and answers, in order. Texts are `pages.home-view.faq.questions.<key>`.
 * `onHome` marks the few the home page shows; /faq shows all. Keys are also what FAQ_OPEN reports.
 *
 * Order: what it is and costs, then "do I have to…" (payments are optional), money, clients, studios,
 * switching over, alerts and data.
 */
export const FAQ_ITEMS = [
  { key: 'website-change', icon: 'mdi-web', onHome: true },
  { key: 'pricing', icon: 'mdi-currency-eur', onHome: true },
  { key: 'payments-optional', icon: 'mdi-toggle-switch-outline', onHome: true },
  { key: 'online-payments', icon: 'mdi-credit-card-outline', onHome: false },
  { key: 'money', icon: 'mdi-bank-transfer', onHome: true },
  { key: 'account', icon: 'mdi-account-outline', onHome: false },
  { key: 'client-register', icon: 'mdi-card-account-details-outline', onHome: false },
  { key: 'trainers', icon: 'mdi-account-group-outline', onHome: false },
  { key: 'switching', icon: 'mdi-swap-horizontal', onHome: true },
  { key: 'notifications', icon: 'mdi-bell-off-outline', onHome: false },
  { key: 'data', icon: 'mdi-shield-lock-outline', onHome: false }
]

export const HOME_FAQ_ITEMS = FAQ_ITEMS.filter(item => item.onHome)
